export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_LOCKEDOUT = 'LOGIN_LOCKEDOUT';
export const LOGIN_FACILITY_SUBSCRIPTION_EXPIRED = 'LOGIN_FACILITY_SUBSCRIPTION_EXPIRED';
export const KIOSK_LOGIN_REQUEST = 'KIOSK_LOGIN_REQUEST';
export const KIOSK_LOGIN_SUCCESS = 'KIOSK_LOGIN_SUCCESS';
export const KIOSK_LOGIN_FAILURE = 'KIOSK_LOGIN_FAILURE';
export const KIOSK_LOCKEDOUT = 'KIOSK_LOCKEDOUT';
export const KIOSK_LOGIN_LOCKEDOUT = 'KIOSK_LOGIN_LOCKEDOUT';
export const INITIATE_PATIENT_KIOSK_USER_LOGIN = 'INITIATE_PATIENT_KIOSK_USER_LOGIN';
export const LOGOUT = 'LOGOUT';
export const TOKEN_UPDATE_REQUEST = 'TOKEN_UPDATE_REQUEST';
export const TOKEN_UPDATE_SUCCESS = 'TOKEN_UPDATE_SUCCESS';
export const TOKEN_UPDATE_FAILURE = 'TOKEN_UPDATE_FAILURE';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const CONFIRM_EMAIL_REQUEST = 'CONFIRM_EMAIL_REQUEST';
export const SINGLESIGNON_LOGIN_SUCCESS = 'SINGLESIGNON_LOGIN_SUCCESS';
export const SINGLESIGNON_LOGIN_FAILURE = 'SINGLESIGNON_LOGIN_FAILURE';
export const PATIENTKIOSKUSER_LOGIN_SUCCESS = 'PATIENTKIOSKUSER_LOGIN_SUCCESS';
export const PATIENTKIOSKUSER_LOGIN_FAILURE = 'PATIENTKIOSKUSER_LOGIN_FAILURE';